// NPM Imports
// Quote Context
// Component Imports
// JS Imports
// Asset Imports

export default function HorizontalRule() {
   return <hr className='bhr1' style={{ order: -99 }}></hr>
}
